import React, { Component } from "react";
import { Button as BootstrapButton } from "react-bootstrap";
import "./button.scss";

export interface ButtonProps {
  className: string;
  value: string;
  onClick: any;
}

export default class Button extends Component<ButtonProps> {
  onClick(e: any) {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  }

  render() {
    return (
      <BootstrapButton
        className={this.props.className || "btn-default"}
        onClick={(e) => {
          this.onClick(e);
        }}
      >
        {this.props.value}
      </BootstrapButton>
    );
  }
}
